import React from "react";
import DealerForm from "./DealerForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const handleDealerSubmit = () => {};

const CreateDealer = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <DealerForm onSubmit={handleDealerSubmit} />
  </DashboardLayout>
);

export default CreateDealer;
